import { connect } from 'react-redux'
import { compose } from 'recompose'
import flags from 'components/common/hoc/flags'
import withType from 'components/common/hoc/withType'
import StoreLocatorSearchSummary from './StoreLocatorSearchSummary'
import { getStoreLocatorState } from '../../selectors'
import { resetSearchAction, fetchLocationsByAddrWithDefaultDistance, setInitialSearchMethodAction } from '../../actions'

export default compose(
  withType({ type: 'BOTStoreLocatorSearchSummary' }),
  connect(getStoreLocatorState,
    {
      resetSearchAction,
      fetchLocationsByAddrWithDefaultDistance,
      setInitialSearchMethodAction
    }
  ),
  flags
)(StoreLocatorSearchSummary)
